import React from "react";

import { makeStyles } from "@material-ui/core/styles";
import Card from "@material-ui/core/Card";
import CardActionArea from "@material-ui/core/CardActionArea";
import CardActions from "@material-ui/core/CardActions";
import CardContent from "@material-ui/core/CardContent";
import CardMedia from "@material-ui/core/CardMedia";
import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";
import ButtonBase from '@material-ui/core/ButtonBase';
const useStyles = makeStyles({
  card: {
    width: 345,
    margin: 'auto'
  },
  media: {
    backgroundSize: 'contain',
    paddingTop: '56.25%', // 16:9
    marginTop: '10px'
  }
});
const FootballCard = props => {
  const classes = useStyles();
  return (
    <Card className={classes.card} onClick={props.onClick}>
      <CardActionArea>
        <CardMedia
          className={classes.media}
          image={props.src}
          title={props.title}
        />
        <CardContent>
          <Typography align="center" variant="h4" component="h2">
            {props.title}
          </Typography>
        </CardContent>
      </CardActionArea>
    </Card>
  );
};

export default FootballCard;
